import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.div`
  width: 55px;
  flex-shrink: 0;
  text-align: left;
  font-size: 12px;
  color: #757575;
  text-transform: uppercase;
  font-weight: 700;
  line-height: 15px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  position: relative;
`;

export const TagImg = styled.img`
  position: absolute;
  top: -8px;
  right: -4px;
  width: 29px;
  height: 14px;
`;

export const Button = styled.button<{ $selected: boolean }>`
  border: 1px solid ${({ $selected }) => ($selected ? "#008cff" : "#d8d8d8")};
  background: ${({ $selected }) => ($selected ? "#eaf5ff" : "#fff")};
  color: ${({ $selected }) => ($selected ? "#008cff" : "#4a4a4a")};
  border-radius: 8px;
  height: 32px;
  padding: 8px;
  font-size: 12px;
  font-weight: ${({ $selected }) => ($selected ? 900 : 400)};
  cursor: pointer;
  white-space: nowrap;
`;

